var OrderedSelect2 = require('app/common/views/input-widgets/ordered-select2');
var PhotoSelector = require('app/common/views/input-widgets/photo-selector');
var Select2 = require('app/common/views/input-widgets/select2');
var TextEditor = require('app/common/views/input-widgets/text-editor');

var InputWidgetViews = {
    OrderedSelect2: OrderedSelect2,
    PhotoSelector: PhotoSelector,
    Select2: Select2,
    TextEditor: TextEditor,
};

module.exports = InputWidgetViews;
